import { Link } from "react-router-dom";
import { MapPin, Clock, ArrowUpRight, Phone } from "lucide-react";

const LOIRET_IMG = "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/j2wvj4th_34565baf-7afd-4c80-9ba1-fc0e2c4b8a35.jpeg";

const LoiretBanner = () => {
    return (
        <section className="bg-white border-y border-black/10" data-testid="loiret-banner">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
                    {/* Image */}
                    <div className="lg:col-span-7 order-2 lg:order-1">
                        <figure className="relative bg-zinc-100 border border-black/10">
                            <img
                                src={LOIRET_IMG}
                                alt="Loiret — votre Département (45) · Château de Sully-sur-Loire"
                                className="w-full h-[280px] sm:h-[380px] lg:h-[460px] object-cover"
                                loading="lazy"
                            />
                            <figcaption className="absolute bottom-0 left-0 right-0 bg-black/70 backdrop-blur-sm text-white px-4 sm:px-6 py-3 flex items-center justify-between">
                                <div className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] font-semibold">
                                    <MapPin className="h-3.5 w-3.5 text-[#E63946]" strokeWidth={2.6} />
                                    Atelier Beauchamp · Serrurerie Express
                                </div>
                                <div className="hidden sm:block text-[10px] uppercase tracking-[0.18em] text-white/60 font-semibold">
                                    24/7
                                </div>
                            </figcaption>
                        </figure>
                    </div>

                    {/* Content */}
                    <div className="lg:col-span-5 order-1 lg:order-2">
                        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-4">
                            ◉ Notre territoire
                        </div>
                            <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight">
                                Intervention<br /><span className="text-[#E63946]">Dépannage Express.</span>
                            </h2>
                            <p className="mt-5 text-base text-zinc-600 leading-relaxed">
                                Atelier Beauchamp intervient dans la commune,
                                jour et nuit, week-ends et jours fériés. Un seul artisan, joignable à toute heure.
                            </p>

                        <div className="mt-7 grid grid-cols-2 gap-4">
                            <div className="border-l border-black/15 pl-4 py-1">
                                <Clock className="h-4 w-4 text-[#E63946] mb-2" strokeWidth={2.4} />
                                <div className="font-display text-xl font-bold tracking-tight">24/7</div>
                                <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 mt-1 font-semibold">Disponibilité</div>
                            </div>
                            <div className="border-l border-black/15 pl-4 py-1">
                                <MapPin className="h-4 w-4 text-[#E63946] mb-2" strokeWidth={2.4} />
                                <div className="font-display text-xl font-bold tracking-tight">~30 min</div>
                                <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 mt-1 font-semibold">Temps moyen</div>
                            </div>
                        </div>

                        <div className="mt-8 flex flex-col sm:flex-row gap-3">
                            <a
                                href="tel:+33649501843"
                                data-testid="loiret-banner-call-btn"
                                className="inline-flex items-center justify-between gap-3 bg-[#0A0A0A] hover:bg-[#E63946] text-white px-5 py-3 transition-colors"
                            >
                                <span className="flex items-center gap-2.5">
                                    <Phone className="h-4 w-4" strokeWidth={2.4} />
                                    <span className="font-display font-bold tracking-tight">06 49 50 18 43</span>
                                </span>
                                <ArrowUpRight className="h-4 w-4" />
                            </a>
                            <Link
                                to="/contact"
                                data-testid="loiret-banner-quote-btn"
                                className="inline-flex items-center justify-between gap-3 border border-black/20 hover:border-black px-5 py-3 transition-colors"
                            >
                                <span className="font-semibold text-xs uppercase tracking-[0.15em]">Devis gratuit</span>
                                <ArrowUpRight className="h-4 w-4" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoiretBanner;
